<template>
	<div>
		<h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Rider {{ (rider.name) ? (" - " + rider.name) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Rider - {{ rider.name }}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Rider - {{ rider.name }}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div v-if="customFormMode == 1">
                <base-input alternative="" label="Code" placeholder="" v-model="rider.code" input-classes="form-control"/>
                <base-input alternative="" label="Name" placeholder="" v-model="rider.name" input-classes="form-control" required/>
                <base-input alternative="" label="Sites" placeholder="">
                    <a-select mode="multiple" v-model="rider.site_ids" input-classes="form-control" placeholder="All Sites" optionFilterProp="children" :filterOption="filterOption" :disabled="$attrs.viewMode">
                        <a-select-option v-for="site in siteOptions" :key="site.id" :value="site.id">
                            {{ site.name }}
                        </a-select-option>
                    </a-select>
                </base-input>
                <base-input alternative="" label="Remark"><textarea rows="4" class="form-control" v-model="rider.remark"/></base-input>
            </div>

            <div v-if="customFormMode == 2">
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="color" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>

            <div v-if="customFormMode == 3">
                <a-tabs defaultActiveKey="1">
                    <base-input alternative="" label="Code" placeholder="" v-model="rider.code" input-classes="form-control"/>
                    <base-input alternative="" label="Name" placeholder="" v-model="rider.name" input-classes="form-control" required/>
                    <base-input alternative="" label="Sites" placeholder="">
                        <a-select mode="multiple" v-model="rider.site_ids" input-classes="form-control" placeholder="All Sites" optionFilterProp="children" :filterOption="filterOption" :disabled="$attrs.viewMode">
                            <a-select-option v-for="site in siteOptions" :key="site.id" :value="site.id">
                              {{ site.name }}
                            </a-select-option>
                        </a-select>
                    </base-input>
                    <base-input alternative="" label="Remark"><textarea rows="4" class="form-control" v-model="rider.remark"/></base-input>
                </a-tabs>
            </div>

            <br><br>
            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                </div>

                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
	</div>
</template>

<script>
	import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import DynamicForm from '../DynamicForm.vue'
    import { mapState } from 'vuex'
    var component_x;

    export default {
        components: {
            DynamicForm
        },

        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },

        mounted: async function () {
            const systemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Rider?field_name=name', null)
            const systemModuleId = systemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + systemModuleId + '?field_name=system_module_id', null)

            if (this.isJsonString(accSystemModuleRequest.meta) == true) {
                const accSystemModule = JSON.parse(accSystemModuleRequest.meta)

                if (accSystemModule != null) {
                    if (accSystemModule.form_mode != undefined) {
                        this.customForm = accSystemModule.form_mode
                    }

                    if (accSystemModule.customized_forms != undefined) {
                        this.customForm = accSystemModule.customized_forms
                    }
                }
            }

            if (this.serverType == 'branch' || this.$attrs.viewMode == true) {
                var form = document.getElementById("form-proper");
                var elements = form.elements;

                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }

            component_x = this
            let sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites", null)
            component_x.siteOptions = sites

            if (component_x.profileId > 0) {
                var rider_data = await HTTPRequest.getRequest(component_x.endPoint + 'riders/' + component_x.profileId, null)
                if (rider_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (rider_data["error"] == undefined) {
                        component_x.rider = rider_data
                        component_x.inputName = rider_data["name"]
                        component_x.inputCode = rider_data["code"]
                        component_x.inputRemark = rider_data["remark"]
                        component_x.inputSiteIds = rider_data["site_ids"]

                        if (!rider_data["site_ids"])
                            rider_data["site_ids"] = []
                    } else {
                        this.errors = rider_data["error"].split(",")
                    }
                }
            }

            this.dynamicFormKey++;
        },

        data: function () {
            return {
                rider: {
                    name: '',
                    code: '',
                    remark: '',
                    site_ids: []
                },
                siteOptions: [],
                errors: [],

                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                formErrors: []
            }
        },

        methods: {
            updateSettings(newFormSettings, settingsGrouping, errors) {
                var formSettingsCopy = this.rider
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors

                if (this.customFormMode == 3) {
                    this.errors = errors
                }

                this.rider = mergedHash
            },

            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },

            validateForm() {
                this.errors = [];
                this.errors.push(ValidateField.charMinAndMax('Code', this.rider.code, 0, 10));
                this.errors.push(ValidateField.required('Name', this.rider.name));
                this.errors.push(ValidateField.charMinAndMax('Name', this.rider.name, 0, 30));
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },

            create: async function () {
                if (!this.validateForm()) {
                    this.rider.code = this.rider.code.trim()
                    this.rider.name = this.rider.name.trim()
                    this.rider.status = 'A'

                    var riderPayload = { rider: this.rider }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'riders', null, riderPayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },

            update: async function () {
                if (!this.validateForm()) {
                    this.rider.code = this.rider.code.trim()
                    this.rider.name = this.rider.name.trim()
                    let status = (this.rider.status == null) ? "A" : this.rider.status
                    this.rider.status = status

                    var riderPayload = { rider: this.rider }
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'riders/' + this.profileId, null, riderPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                );
            },
        }
    }
</script>